import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CodeManagementApiService } from 'shared/services';

@Pipe({
  name: 'codeValue'
})
export class CodeValuePipe implements PipeTransform {
  constructor(private translateService: TranslateService, private codeManagementApiService: CodeManagementApiService) {
  }

  transform(value: string, typeCode: string): string {
    if (!this.codeManagementApiService.codeCache[typeCode]) {
      throw `Code type ${typeCode} is not found`;
    }
    return this.codeManagementApiService.codeCache[typeCode].filter(x => x.key === value)[0]?.value[this.translateService.currentLang];
  }

}
